import logger from 'loglevel';
import prefixer from 'loglevel-plugin-prefix';
logger.setLevel('info');
let alreadyConfigured = false;
function configure() {
    if (alreadyConfigured) {
        return;
    }
    prefixer.reg(logger);
    prefixer.apply(logger, {
        timestampFormatter: (date) => date.toISOString(),
    });
    alreadyConfigured = true;
}
const myLogger = logger;
myLogger.configure = configure;
export default myLogger;
//# sourceMappingURL=logger.js.map